import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAllAsync,
  selectEmpresasEstrangeiras,
} from '../../../../../features/empresa-estrangeira/empresaEstrangeiraSlice';
import MultiSelectFormInput from '../../../../common/components/forms/MultiSelectFormInput';

type Props = {
  name: string;
  label: string;
  required?: boolean;
};

function MultiSelectExportador({ name, label, required }: Props) {
  const dispatch = useDispatch();
  const empresas = useSelector(selectEmpresasEstrangeiras);

  useEffect(() => {
    dispatch(fetchAllAsync());
  }, [dispatch]);

  const options = useMemo(
    () =>
      (empresas ?? [])
        .filter((empresa: any) => empresa?.exportador && empresa?.active)
        .map((empresa: any) => {
          const nome = empresa?.pessoaJuridica?.nomeResumido ?? empresa?.description ?? `#${empresa.id}`;
          const cnpj = empresa?.pessoaJuridica?.cnpj ?? empresa?.cpfCnpjFabricante;
          return {
            id: empresa.id,
            value: cnpj ? `${nome} - ${cnpj}` : nome,
          };
        }),
    [empresas]
  );

  return <MultiSelectFormInput name={name} options={options} label={required ? `${label} *` : label} />;
}

export default MultiSelectExportador;
